// src/pages/purchase-requisition/components/RejectConfirmDialog.jsx
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    TextField
} from "@mui/material";

function RejectConfirmDialog({ open, onClose, onConfirm, rejectionNote, setRejectionNote }) {
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="reject-dialog-title">
            <DialogTitle id="reject-dialog-title">Konfirmasi Penolakan</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    Apakah Anda yakin ingin menolak order ini?
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="rejection-note"
                    label="Catatan Penolakan (Opsional)"
                    type="text"
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    value={rejectionNote}
                    onChange={(e) => setRejectionNote(e.target.value)}
                />
            </DialogContent>
            <DialogActions sx={{ pt: "20px", pb: "20px", pl: "24px", pr: "24px" }}>
                <Button onClick={onClose}>Batal</Button>
                <Button onClick={onConfirm} variant="contained" color="error">
                    Tolak
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default RejectConfirmDialog;
